import type {ReactElement} from 'react';
import React from 'react';
import {ItemWithDualFontOptions} from '@Components/poster-editor/components/poster-editing-side-panel/components/item-with-dual-font-options';
import {ItemFontOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/item-font-option';
import {ItemStylingOptions} from '@Components/poster-editor/components/poster-editing-side-panel/components/item-styling-options';
import {doesLayoutItemHasDualFonts} from '@Components/poster-editor/library/poster-editor-library';
import {FontFamilyOptionType} from '@Components/poster-editor/components/poster-editing-side-panel/components/item-with-dual-font-options/item-with-dual-font-options.types';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromTableItem} from '@Hooks/poster-editor/useGetKeyFromTableItem';
import type {LayoutTypes} from '@PosterWhiteboard/items/layouts/layout.types';

interface TableStylingOptionsProps {
  onClickFontButton(clickedFontOption: FontFamilyOptionType): void;
}

export function TableStylingOptions({...props}: TableStylingOptionsProps): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const layoutStyle = useGetKeyFromTableItem('layoutStyle') as LayoutTypes;

  if (!activeItem || (activeItem && !('layoutStyle' in activeItem)) || layoutStyle === undefined) {
    throw new Error(`Item doesn't have layoutStyle property - cannot determine the type of font styling options to show!`);
  }

  if (doesLayoutItemHasDualFonts(layoutStyle)) {
    return (
      <ItemWithDualFontOptions
        onClickFontButton={(clickedFontOption): void => {
          props.onClickFontButton(clickedFontOption);
        }}
      />
    );
  }

  return (
    <>
      <ItemFontOption
        onClickFontButton={(): void => {
          props.onClickFontButton(FontFamilyOptionType.ONLY_FONT);
        }}
      />
      <ItemStylingOptions />
    </>
  );
}
